import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DEV_CONFIG } from '../models/config.model';
import { StatusPageModel } from '../models/status-page.model';

@Injectable({
  providedIn: 'root',
})
export class StatusPageService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(DEV_CONFIG);

  getStatusPage(): Observable<StatusPageModel> {
    let url = this.config.statusPageUrl + '/api/v2/status.json';
    url = url.replace(/[?&]$/, '');

    return this.http.get<StatusPageModel>(url);
  }
}
